import React from 'react'
import type { HealthStatus } from '@/types/status'
import { StatusDot } from '@/components/data-display/StatusDot'
import { TrendPill } from '@/components/data-display/TrendPill'

interface MetricCardProps {
  title: string
  value: React.ReactNode
  delta?: number
  deltaSuffix?: string
  status?: HealthStatus
  subtitle?: string
  className?: string
}

export function MetricCard({
  title,
  value,
  delta,
  deltaSuffix,
  status,
  subtitle,
  className = '',
}: MetricCardProps) {
  return (
    <div className={`surface p-5 flex flex-col gap-2 ${className}`}>
      <div className="flex items-center justify-between">
        <span className="text-small text-text-dim">{title}</span>
        {status && <StatusDot status={status} />}
      </div>
      <div className="text-display text-text tabular-nums">{value}</div>
      {(delta !== undefined || subtitle) && (
        <div className="flex items-center gap-2">
          {delta !== undefined && <TrendPill value={delta} suffix={deltaSuffix} />}
          {subtitle && <span className="text-tiny text-text-dim">{subtitle}</span>}
        </div>
      )}
    </div>
  )
}
